import { z } from "zod";

/** OSS `GET .../s3/bucket/:bucket/object?overview=true&key=...` */
export const objectOverviewResponseSchema = z
  .object({
    key: z.string().optional(),
    bucket: z.string().optional(),
    region: z.string().optional(),
    arn: z.string().optional(),
    size: z.union([z.number(), z.string()]).optional(),
    sizeInBytes: z.number().optional(),
    type: z.string().optional(),
    contentType: z.string().optional(),
    lastModified: z.string().optional(),
    /** HTTPS object URL */
    httpsUrl: z.string().optional(),
    /** s3://bucket/key */
    s3Uri: z.string().optional(),
    /** Legacy / alternate field names */
    uri: z.string().optional(),
    /** S3 ETag (often quoted) */
    eTag: z.string().optional(),
    etag: z.string().optional(),
    serverSideEncryption: z.string().optional(),
  })
  .passthrough();

export type ObjectOverviewResponse = z.infer<typeof objectOverviewResponseSchema>;
